import { CLUSTER } from '../constants';

export async function searchGenerators(query, nextUrl = null, signal = null) {
  try {
    if (!query || query.trim().length === 0) {
      return { items: [], next: null };
    }

    // Use the full next URL if provided, otherwise build initial URL
    const url = nextUrl || `/island-api/v1/search/generators?query=${encodeURIComponent(query)}&page_size=20`;

    const response = await fetch(url, signal ? { signal } : undefined);
    if (!response.ok) {
      throw new Error(`Failed to search generators: ${response.status}`);
    }
    const data = await response.json();

    // Strip domain from next URL in dev environment
    let nextUrlResult = data.next || null;
    if (CLUSTER === 'dev' && nextUrlResult) {
      try {
        const urlObj = new URL(nextUrlResult, window.location.origin);
        nextUrlResult = urlObj.pathname + urlObj.search;
      } catch (e) {
        console.warn('Failed to parse next URL:', e);
      }
    }

    // Extract content_object from each item
    const items = Array.isArray(data?.items)
      ? data.items.map(item => item.content_object).filter(Boolean)
      : [];

    return {
      items,
      next: nextUrlResult,
    };
  } catch (e) {
    if (e.name === 'AbortError') {
      // Request was aborted - this is expected behavior
      return { items: [], next: null };
    }
    console.error(`Failed to search generators: ${e.message}`);
    return { error: e.message || 'Failed to search generators' };
  }
}
